module.exports = __webpack_public_path__ + "static/img/Group.d9eed63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/social/pages/Group.png
// module id = E0M3
// module chunks = 134